<mat-card appearance="outlined" style="max-width: 750px;  margin: 10px;" [ngClass]="setClass()"  >

  <!-- <table>
    <tr>
      <td style="width: 32px;">  <mat-icon style="font-size: 30px;">person</mat-icon>
    </td>
    <td>

      <div style="font-size: 16px;">{{this.Report.CreatedByLastName}}, {{this.Report.CreatedByFirstName}}

      </div>
      <div style="font-size: 12px;">{{this.Report.DateCreated | date:'yyyy-MM-dd HH:mm' }}</div>



    </td>
  </tr>
</table> -->

<mat-card-content style="margin-bottom: 0px;" >



  <div style="font-size: 12px; padding: 5px; white-space:pre-line;">
    {{this.Report.Text}}
  </div>
  <mat-divider></mat-divider>
  <app-report-overall-grades 
    [TotalQualityText]="this.Report.TotalQualityText" [TotalQuality]="this.Report.TotalQuality" 
    [GamePerformanceText]="this.Report.GamePerformanceText" [GamePerformance]="this.Report.GamePerformance"
    [CapacityText]="this.Report.PlayerCapacityText"  [Capacity]="this.Report.PlayerCapacity"
    [CurrentLevelRankingText]="this.Report.CurrentLevelRankingText" [CurrentLevelRanking]="this.Report.CurrentLevelRanking"
   ></app-report-overall-grades>
  <mat-divider></mat-divider>


  <div style="font-family: verdana,arial,sans-serif; font-size: x-small;  text-align: left; vertical-align: top;  padding: 0; white-space: normal; margin: 0; ;  ">
    <table>

      <tr >
        <td >
          <mat-icon style="font-size: 18px;"> cake</mat-icon>
        </td>
        <td>
          <div style="font-size: 10px;">
            {{this.Report.PlayerAgeYear}} years {{this.Report.PlayerAgeMonth}} months
          </div>
        </td>
      </tr>
      <tr>
        @if (this.Report.GameText) {
          <td>
            <mat-icon style="font-size: 18px;">sports_hockey</mat-icon>
          </td>
        }
        @if (this.Report.GameText) {
          <td>
            <div style="font-size: 10px;">
              {{this.Report.GameText}}     <br>
              <span>{{this.Report.ReportDivision}}</span>
            </div>
          </td>
        }
        </tr>
        <tr>
        @if (this.Report.Location) {
          <td>
            <mat-icon style="font-size: 18px;"> location_on</mat-icon>
          </td>
        }
        @if (this.Report.Location) {
          <td>
            <div style="font-size: 10px;">
              {{this.Report.Location}}
            </div>
          </td>
        }

      </tr>
         <tr>
          <td>
            <mat-icon style="font-size: 24px; height: 24px;">person</mat-icon>
          </td>
          <td>
            <div style="font-size: 12px;">{{this.Report.CreatedByLastName}}, {{this.Report.CreatedByFirstName}}  <span style="color: gray;font-size: 12px; color: darkgray;">- {{getTimeAgo()}} ({{this.Report.DateCreated | date:'yyyy-MM-dd HH:mm' }})</span></div>

          </td>
        </tr>

    </table>



  </div>


  
 <!--    <app-report-view-skills [SkillGroups]="this.Report.SkillGroups"></app-report-view-skills> -->



</mat-card-content>
<mat-card-actions>
@if (this.Report.IsCreatedByCurrentUser) {
  <button mat-button [routerLink]="['/scouting/editreport', this.Report.ReportId]" >
    EDIT
  </button>
}

<!-- <button mat-icon-button style="opacity: 0.6;" (click)="gotoPlayerDetails(this.Report.PlayerId)" ><img style="height: 24px;"   src="../../assets/img/icons8-user-shield-48.png"></button>
-->
@if (this.Report.GameId) {
  <a mat-button  type="button" [routerLink]="[ '/scouting/gamedetails', this.Report.GameId ]">
    <!--    <mat-icon style="font-size: 18px; opacity: 0.6;">
    sports_hockey
  </mat-icon>      -->
  GAME
</a>
}
<!-- <button mat-button style="opacity: 0.6;" (click)="gotoPlayerDetails()" ><img style="height: 24px;"   src="../../assets/img/icons8-user-shield-48.png">Player</button>
<button mat-button style="opacity: 0.6;" (click)="gotoPlayerDashboard()" ><img style="height: 24px;"   src="../../assets/img/icons8-user-shield-48.png">Player</button>
<button mat-button style="opacity: 0.6;" >
  <mat-icon style="font-size: 18px; opacity: 0.6;">sports_hockey</mat-icon>
  Game
</button> -->
</mat-card-actions>
</mat-card>


